export enum ProfilePageType {
  ITEMS = "items",
  LISTINGS = "listings",
  ACTIVITY = "activity",
  OFFERS = "offers",
}
